import moment from 'moment-timezone'
import isEmpty from '../is-empty'
import { TIME_ZONE } from '../../model/time'
import translator from 'src/translate'

/**
 *
 * @param value
 */

const ConverterDateToAssignmentFormat = function (value) {
  if (isEmpty(value)) {
    return translator._('assignment.undefined')
  } else {
    let date = moment.tz(value, TIME_ZONE.ISTANBUL)

    let converted = date
      .clone()
      .tz(window.CONSTANTS.TIME_ZONE)
      .format('DD.MM.YYYY • hh:mm A')

    return converted
  }
}

export default ConverterDateToAssignmentFormat
